import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { AlertService, AuthService } from '@app/core/services';
import { User } from '@app/core/models';
import { ContextMenuComponent } from '@progress/kendo-angular-menu';
import { environment } from '@environments/environment';


@Component({
  selector: 'base-contextmenu',
  template: `
    <kendo-contextmenu [items]="items" (select)="onSelect($event)"></kendo-contextmenu>`,
})
export class BaseContextmenuComponent {  

  //ContextMenu
  @ViewChild(ContextMenuComponent, {static: false}) menu !: ContextMenuComponent;

  //Variables

  public contextItem: any = null;

  public currentUser: User;

  //Eventos

  @Output() select: EventEmitter<any> = new EventEmitter<any>();  


  constructor(protected authService: AuthService, protected alertService: AlertService) {
            
    // console.log(this.constructor.name);
    this.authService.currentUser.subscribe(x => { 
      this.currentUser = x;
    });    
    
  }

  protected onSelect(event): void {

    console.log(this.constructor.name + ":onSelect", event.item, this.contextItem);    
    //Overrides

  }

}
